import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateAppointmentRequest,
  CreateAppointmentResponse,
  UpdateAppointmentStatusRequest,
  UpdateAppointmentStatusResponse,
} from "../../models/Appointment.model";
import { environment } from "../../environments";
import {
  CreateAppointmentTypeRequest,
  CreateAppointmentTypeResponse,
  DeleteAppointmentTypeRequest,
  DeleteAppointmentTypeResponse,
} from "../../models/AppointmentType.model";
const API_URL = environment.apiUrl;

const normalizeAppointmentRequest = (
  request: CreateAppointmentRequest,
): CreateAppointmentRequest => ({
  ...request,
  ProjectID: Number(request.ProjectID) || 0,
  AppointmentID: Number(request.AppointmentID) || 0,
  ContactID: Number(request.ContactID) || 0,
  EmployeeID: Number(request.EmployeeID) || 0,
  TypeID: Number(request.TypeID) || 0,
  Status: Number(request.Status) || 0,
  ScheduledStart:
    typeof request.ScheduledStart === "string"
      ? request.ScheduledStart
      : request.ScheduledStart.toISOString(),
  ScheduledEnd:
    typeof request.ScheduledEnd === "string"
      ? request.ScheduledEnd
      : request.ScheduledEnd.toISOString(),
});

export const getAppointmentTypes = createAsyncThunk<
  any,
  { Token: string; CompanyKey: string },
  { rejectValue: string }
>("appointments/getAppointmentTypes", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Appointment/GetAppointmentType`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return rejectWithValue(errorData.message || "שגיאה בקריאת סוגי פגישות");
    }

    const data = await response.json();
    return data.appointments;
  } catch (error) {
    return rejectWithValue("שגיאה בחיבור לשרת");
  }
});

export const createOrUpdateAppointment = createAsyncThunk<
  CreateAppointmentResponse,
  CreateAppointmentRequest,
  { rejectValue: string }
>(
  "appointment/createOrUpdateAppointment",
  async (request, { rejectWithValue }) => {
    try {
      const normalizedRequest = normalizeAppointmentRequest(request);
      const response = await fetch(
        `${API_URL}Appointment/CreateOrUpdateAppointment`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(normalizedRequest),
        },
      );

      const res = await response.json();

      if (!response.ok) {
        return rejectWithValue(
          res?.message || res?.Message || "שגיאה ביצירת פגישה",
        );
      }

      return res.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.Message || "שגיאה ביצירת פגישה",
      );
    }
  },
);
export const updateAppointmentStatus = createAsyncThunk<
  UpdateAppointmentStatusResponse,
  UpdateAppointmentStatusRequest,
  { rejectValue: string }
>("appointments/updateStatus", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${API_URL}Appointment/UpdateAppointmentStatus`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      },
    );

    if (!response.ok) {
      const errorData = await response.json();
      return rejectWithValue(errorData.message || "שגיאה בעדכון סטטוס פגישה");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return rejectWithValue("שגיאה בחיבור לשרת");
  }
});

export const createAppointmentType = createAsyncThunk<
  CreateAppointmentTypeResponse,
  CreateAppointmentTypeRequest,
  { rejectValue: string }
>(
  "appointments/createAppointmentType",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}Appointment/CreateAppointmentType`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(request),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message || "שגיאה ביצירת סוג פגישה");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue("שגיאה בחיבור לשרת");
    }
  },
);
export const deleteAppointmentType = createAsyncThunk<
  DeleteAppointmentTypeResponse,
  DeleteAppointmentTypeRequest,
  { rejectValue: string }
>(
  "appointments/deleteAppointmentType",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}Appointment/DeleteAppointmentType`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(request),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.message || "שגיאה במחיקת סוג פגישה");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue("שגיאה בחיבור לשרת");
    }
  },
);
